export default function getTarget(evt) {
  let targ;

  if (!evt) {
    evt = window.event;
  }

  if (evt.target) {
    targ = evt.target;
  } else if (evt.srcElement) {
    targ = evt.srcElement;
  }

  if (targ.nodeType == 3) {
    targ = targ.parentNode;
  }

  return targ;
}
